<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12  pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :error="errors.length > 0"
                             :messagesChampsVide="errors"
                             :champsVide="[]"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>

      <div class="column is-12 mgt-5px">
        <a @click="toggleBrief()">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{$t('reseauTempo.briefContent.brief')}}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{$t('reseauTempo.briefContent.appliquerBrief')}}
        </span>
      </div>
    </div>
    <div class="column  overflow-auto"
         :class="[
      {'hauteur-brief-filtre': errors.length === 0},
      {'hauteur-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="columns is-multiline is-12 is-marginless is-paddingless">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('reseauTempo.briefContent.location')" class="obligatoire">
            <b-select v-model="brief.produitLocation" expanded>
              <option
                v-for="location in produitsLocation"
                :key="location.id"
                :value="location">
                {{location.libelle}}
                <span v-if="location.reference"> - {{location.reference}} </span>
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('reseauTempo.briefContent.codeReseau')">
            <qd-taginput v-model="brief.references" type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('reseauTempo.briefContent.libelle')">
            <qd-taginput v-model="brief.libelles" type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('reseauTempo.briefContent.villes')">
            <ville-tag-input-auto-complete
                :critere-recherche="brief"
                table-name="Produit"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('reseauTempo.briefContent.departements')">
            <qd-taginput v-model="brief.departements" type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('reseauTempo.briefContent.formats')">
            <qd-taginput :value="getFormatSave"
                        :data="formatListe"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        type="is-primary"
                        icon="magnify"
                        @remove="deleteFormatInBrief"
                        @add="addFormatInBrief"
                        @typing="getFilteredFormat">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field :label="$t('reseauTempo.briefContent.type')">
            <qd-taginput v-if="typeReseauTags"
                        v-model="typesReseauSelected"
                        :data="typeReseauTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredTypeReseauTags"
                        @input="getTypeReseauTag">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
        <b-field :label="$t('reseauTempo.briefContent.budgetMax')">
          <input-currency v-model="brief.budgetMax"
                          isNumber="true"
                          size="default">
          </input-currency>
        </b-field>
      </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('reseauTempo.briefContent.reseauConfrere')">
            <qd-switch v-model="brief.inclureConfreres">
            </qd-switch>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="societesInformations.length > 1
        && !filtrerProduitParSociete && !filtrerProduitParAgence">
          <b-field :label="$t('reseauTempo.briefContent.societe')">
            <b-select v-model="brief.societeId" expanded>
              <option :value=null></option>
              <option v-for="societe in societesInformations"
                      :key="societe.id"
                      :value="societe.id">
                {{ societe.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="agencesInformations.length > 1">
          <b-field :label="$t('reseauTempo.briefContent.agence')">
            <qd-taginput v-if="agenceTags"
                        v-model="agenceSelected"
                        :data="agenceTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelleAgence"
                        @typing="getFilteredAgenceTags"
                        @input="getAgenceTag">
            </qd-taginput>
          </b-field>
        </div>
      </div>
      <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
        <secteur-tag-input v-model="secteursSelected"
          :label="$t('detailsPlanningFaceUnitaire.filtre.secteur')"
          :critere="(el) => el.type === constantes.COMMERCIAL"
          :disabled="secteurCurrentUser.length > 0">
        </secteur-tag-input>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-brief-filtre border-pied pdt-0">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="saveBrief()">
        {{$t('reseauTempo.briefContent.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pdl-10px"
        @click="viderBrief()">
        {{$t('reseauTempo.briefContent.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import validationBriefPlanningReseauTempo from '@/services/devisCommandes/validation/validationBriefPlanningReseauTempo';
import * as typesProduitFace from '@/store/modules/produitFace-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';

const reseauTempo = createNamespacedHelpers('planningReseauTempo');
const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  props: {
    produitsLocation: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      brief: null,
      errors: [],
      formatListe: [],
      listeTypeReseauBase: [],
      typesReseauSelected: [],
      typeReseauTags: null,
      agenceTags: null,
      listeAgenceBase: null,
      agenceSelected: [],
      secteursSelected: [],
      secteurCurrentUser: [],
      constantes: {
        COMMERCIAL,
      },
    };
  },
  components: {
    inputCurrency,
    errorMsgComponent,
    VilleTagInputAutoComplete,
    secteurTagInput,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...reseauTempo.mapGetters({
      briefStocke: 'brief',
    }),
    ...societe.mapGetters({
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      agenceActive: 'agenceActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    getFormatSave() {
      const libelleFormat = [];
      if (!this.briefStocke.formats) { return []; }
      this.briefStocke.formats.forEach((formatId) => {
        libelleFormat.push(
          this.getFormat.find((format) => { return format.id === formatId; }).libelle,
        );
      });
      return libelleFormat;
    },
    getFormat() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.format).filter(f => f.actif);
    },
    typeReseau() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.typeReseau)
        .filter(typeReseau => typeReseau.actif);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
      );
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
      );
    },
    moduleSecteurActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    secteurs() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.secteur);
    },
  },
  methods: {
    ...reseauTempo.mapMutations({
      setBrief: typesProduitFace.SET_BRIEF,
      clearBrief: typesProduitFace.CLEAR_BRIEF,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getFilteredFormat(text) {
      if (!text) { this.formatListe = this.getFormat; }
      this.formatListe = this.getFormat.filter((option) => {
        return option.libelle.toString().toLowerCase().includes(text.toLowerCase()) > 0;
      });
    },
    deleteFormatInBrief(value) {
      this.brief.formats.splice(this.brief.formats.findIndex((format) => {
        return format.id === value.id;
      }), 1);
    },
    addFormatInBrief(value) {
      if (!this.brief.formats) { this.brief.formats = []; }
      this.brief.formats.push(value.id);
    },
    viderBrief() {
      this.clearBrief();
      this.brief = cloneDeep(this.briefStocke);
      if (this.brief.agencesId === null) {
        this.agenceSelected = this.listeAgenceBase.filter(
          a => this.agenceActive.map(ag => ag.agenceId).includes(a.agenceId),
        );
        this.brief.agencesId = this.agenceSelected.map(a => a.agenceId);
      }
      this.typesReseauSelected = [];
      this.getTypeReseauTag();
      this.getAgenceTag();
      if (this.moduleSecteurActive) {
        this.secteursSelected = this.secteurCurrentUser ?? [];
        this.brief.secteurIds = this.secteursSelected.map(s => s.id);
      }
    },
    saveBrief() {
      this.errors = [];
      if (this.moduleSecteurActive) {
        this.brief.secteurIds = this.secteursSelected.map(s => s.id);
      }
      validationBriefPlanningReseauTempo(this.brief, this.errors);
      if (this.errors.length === 0) {
        this.brief.typeReseauIds = this.typesReseauSelected.map(t => { return t.id; });
        this.brief.agencesId = this.agenceSelected.map((agence) => agence.agenceId);
        this.setBrief(this.brief);
        this.toggleBrief();
        this.$emit('appliquerBrief');
      }
    },
    toggleBrief() {
      this.$emit('toggleBrief');
    },
    getFilteredTypeReseauTags(text) {
      this.getTypeReseauTag();
      this.typeReseauTags = this.typeReseauTags.filter((typeReseau) => {
        return typeReseau.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getTypeReseauTag() {
      this.typeReseauTags = this.listeTypeReseauBase.filter((typeReseau) => {
        return !this.typesReseauSelected.map(a => a.id).includes(typeReseau.id);
      });
    },
    getFilteredAgenceTags(text) {
      this.getAgenceTag();
      this.agenceTags = this.agenceTags.filter((agence) => {
        return agence.libelleAgence.toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
    getAgenceTag() {
      this.agenceTags = this.listeAgenceBase.filter((agence) => {
        return !this.agenceSelected.map(a => a.agenceId)
          .includes(agence.agenceId);
      });
    },
  },
  async created() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.brief = cloneDeep(this.briefStocke);
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.format,
        typesParametres.PARAMETRES_KEYS.typeReseau,
        typesParametres.PARAMETRES_KEYS.secteur,
      ]);
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
      ]);
      this.formatListe = await this.getFormat;
      this.listeTypeReseauBase = this.typeReseau;
      this.typesReseauSelected = this.listeTypeReseauBase.filter((c) => {
        return this.brief.typeReseauIds.includes(c.id);
      });
      this.getTypeReseauTag();
      if (this.filtrerProduitParAgence) this.listeAgenceBase = cloneDeep(this.agenceActive);
      else this.listeAgenceBase = cloneDeep(this.agencesInformations);
      if (this.brief.agencesId) {
        this.agenceSelected = this.listeAgenceBase.filter((c) => {
          return this.brief.agencesId.includes(c.agenceId);
        });
      }
      this.getAgenceTag();
      if (this.moduleSecteurActive) {
        this.secteurCurrentUser = await getSecteursIdByUser(this.constantes.COMMERCIAL, true);
        if (this.secteurCurrentUser?.length > 0) {
          this.secteursSelected = this.secteurCurrentUser;
        }
        if (this.brief.secteurIds.length > 0) {
          this.secteursSelected = this.secteurs.filter((s) => {
            return this.brief.secteurIds.includes(s.id) && s.actif === true;
          });
        }
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
